
import { supabase } from '@/integrations/supabase/client';

export class WhisperAIService {
  static async transcribeAudio(audioBlob: Blob): Promise<string> {
    try {
      // Use hardcoded Groq API key for Whisper
      const apiKey = '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';

      const formData = new FormData();
      formData.append('file', audioBlob, 'audio.webm');
      formData.append('model', 'whisper-large-v3');
      formData.append('response_format', 'json');
      formData.append('language', 'en');


      const response = await fetch('https://api.groq.com/openai/v1/audio/transcriptions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${apiKey}`,
        },
        body: formData,
      });


      if (!response.ok) {
        const errorText = await response.text();
        console.error('Groq Whisper API error:', response.status, errorText);
        throw new Error(`Whisper API error: ${response.status} - ${errorText}`);
      }

      const data = await response.json();

      return data.text || '';
    } catch (error) {
      console.error('Whisper transcription error:', error);
      throw new Error(`Failed to transcribe audio: ${error.message}`);
    }
  }
}
